import { BaseController } from '@shared/basecontroller.controller';
import { EcopayzForm } from './ecopayzform.model';

class EcopayzFormController extends BaseController {
  constructor(DepositStore, EventDispatcherService, FormService, PaymentOptionApiService, TransactionApiService, $timeout) {
    'ngInject';

    super();

    this.DepositStore = DepositStore;
    this.EventDispatcherService = EventDispatcherService;
    this.FormService = FormService;
    this.PaymentOptionApiService = PaymentOptionApiService;
    this.TransactionApiService = TransactionApiService;
    this.$timeout = $timeout;
  }

  $onInit() {
    this.userCurrency$ = this.DepositStore.getCurrency();

    this.form = new EcopayzForm(this.details.customerProducts, this.details.paymentOptions);
    this.paymentOptionsViewDetails = this.details.paymentOptionsViewDetails;

    this.form.paymentOption = this.selectedPaymentOption.id;
    this.form.paymentOptionType = this.selectedPaymentOption.type;
    this.form.feeMultiplier = this.paymentOptionsViewDetails.feeFor('deposit');
    this.form.feeFree = this.paymentOptionsViewDetails.isFeeFreeFor('deposit');
    this.form.email = this.selectedPaymentOption.extras.accountId;

    this.$timeout(() => {
      $(".gateway-sidebar-wrap .fa-receipt").click(function(e){
        e.preventDefault();
        $(".gateway-sidebar-wrap").toggleClass('active');
      });
    }, 500);    
  }

  submit() {
    this.FormService.isSubmitting.next(true);
      this.DepositStore.deposit(this.form.toPayload())
      .then(() => this.handleSuccessfulSubmission())
      .catch((errors) => {
        console.log(errors);
        this.form.error.setFormErrors(errors);
        this.FormService.isSubmitting.next(false);
      })
    ;
  }

  handleSuccessfulSubmission() {
    this.FormService.isSubmitting.next(false);
    this.onSuccessfulSubmission({form: this.form, viewDetails: this.paymentOptionsViewDetails});
  }

  resetForm() {
    this.form.reset();
  }

  removeSubTransaction(subTransaction, index) {
    this.form.removeSubTransaction(subTransaction, index);
  }

  formatAmount(subTransaction) {
    return subTransaction.amount = parseFloat(subTransaction.amount);
  }

  get displayDeleteButton() {
    return this.form.subTransactions.length > 1;
  }
}

export default EcopayzFormController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/deposit/component/form/ecopayz/ecopayzform.controller.js